import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "tw-grid tw-grid-cols-2" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "tw-grid tw-grid-cols-3 tw-text-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "Completed", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, "Answers", -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, "Correct Answers", -1)
const _hoisted_14 = { class: "sf-table tw-w-full" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Question"),
    /*#__PURE__*/_createElementVNode("th", { class: "!tw-text-center tw-text-nowrap" }, "Your Answer"),
    /*#__PURE__*/_createElementVNode("th", { class: "!tw-text-center tw-text-nowrap" }, "Correct Answer")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrintTest = _resolveComponent("PrintTest")!
  const _component_MathsTestResultItem = _resolveComponent("MathsTestResultItem")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        (_ctx.printEnabled)
          ? (_openBlock(), _createBlock(_component_PrintTest, {
              key: 0,
              "maths-test-id": _ctx.currentResultId,
              score: _ctx.currentResult
            }, null, 8, ["maths-test-id", "score"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        (_ctx.testResults.length > 1)
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 0,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentTestIndex) = $event)),
              class: "sf-form-control"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testResults, (tr, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: tr.id,
                  value: index
                }, _toDisplayString(_ctx.$filters.timeFormat(tr.createdon, "[dn] [d] [mn] [y] [h]:[i]", true)), 9, _hoisted_2))
              }), 128))
            ], 512)), [
              [_vModelSelect, _ctx.currentTestIndex]
            ])
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.currentResult !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _createTextVNode(" Date of test: "),
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.$filters.timeFormat(_ctx.currentResult.createdon, "[dn] [d] [mn] [y] [h]:[i]", true)), 1)
            ]),
            (_ctx.student)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Student: " + _toDisplayString(_ctx.student.fullName), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _hoisted_7,
              (_ctx.wasCompleted)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Yes"))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, "No"))
            ]),
            _createElementVNode("div", null, [
              _hoisted_10,
              (_ctx.wasCompleted)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.currentResult.total_answers), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.currentResult.total_answers) + " / " + _toDisplayString(_ctx.currentResult.question_count), 1))
            ]),
            _createElementVNode("div", null, [
              _hoisted_13,
              _createElementVNode("div", null, _toDisplayString(_ctx.currentResult.correct_answers) + " (" + _toDisplayString(_ctx.$filters.renderPercent(
                _ctx.currentResult.correct_answers / _ctx.currentResult.total_answers,
              )) + ") ", 1)
            ])
          ]),
          _createElementVNode("table", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (r, idx) => {
                return (_openBlock(), _createBlock(_component_MathsTestResultItem, {
                  key: idx,
                  question: r
                }, null, 8, ["question"]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}